import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const TabNavigationWidget: WidgetRegistryEntry = {
  name: "TabNavigation",
  configuration: () => import("./configuration").then((m) => m.TabNavigationWidgetConfiguration),
  component: () => import("./tab-navigation-widget.component").then((m) => m.TabNavigationWidgetComponent)
};
